import React, { useCallback } from 'react';
import { RefreshControl, ScrollView, TouchableHighlight, View } from 'react-native';
import { useTheme } from '@config';
import { Header, SafeAreaView, Icon } from '@components';
import { connect, useDispatch, useSelector } from 'react-redux';
import { userActions } from '@actions';
import { useFocusEffect } from '@react-navigation/native';
import { userSelector } from '../../selectors';
import * as SplashScreen from 'expo-splash-screen';
import { Text } from '../../components';
import { BaseColor, BaseStyle } from '../../config';
import { useEffect } from 'react';
import { useState } from 'react';
import { ActivityIndicator } from 'react-native';
import { Linking } from 'react-native';
import { actionActions } from '../../redux/actions';
import { assignUserToStore, getSingleStore } from '../../helpers';

function AssignUserToStore({ getSingleAction, getUserAuth, assignUser, getAllUser, allUser, navigation, route }) {
    const { colors } = useTheme();
    const dispatch = useDispatch();
    const user = useSelector(userSelector.user);
    
    const [state, setState] = useState({
        store: route.params.store,
        loading: false,
    });

    useFocusEffect(
        useCallback(() => {
            getUserAuth();
            return () => {};
        }, [])
    );

    useEffect(() => {
        onRefresh();
    }, []);

    function onRefresh() {
         getSingleStore(`${state.store.id}`,null, (resp) => {
                       
             setState((s) => ({ ...s, store: { ...resp} }));
         },null);
        getAllUser();
    }
    if (!user) {
        return <View></View>;
    }
    const onLayoutRootView = useCallback(async () => {
        await SplashScreen.hideAsync();
    }, []);
    
    function selectUser(user) {
        let currentusers = state.store.assignedUsers;
        let newUsers = isSelected(user.id) ? currentusers.filter((u) => u.id != user.id) : [...currentusers, user];
        setState((s) => ({ ...s, loading: false, store: { ...s.store, assignedUsers: newUsers } }));
    }
    function isSelected(id) {
        return state.store?.assignedUsers?.findIndex((user) => user.id == id) >= 0;
    }
    
    const users = allUser?.rows
    ?.filter((user) =>( user?.roles[0]?.value != 2) && user.positions?.find(position=>position.access=="ZM"&&position.clientId==state.store?.action?.clientId)?.id!=null  ).sort((a,b)=>a.firstname.localeCompare(b.firstname)).sort((a,b)=>isSelected(b.id) - isSelected(a.id))
    
    return (
        <View style={{ flex: 1 }} onLayout={onLayoutRootView}>
            <Header
                title="Zuweisung verwaltung"
                subTitle={state.store.name}
                //shadow
                renderLeft={() => {
                    return <Icon name="arrowleft" size={25} type="ad" color={colors.text} enableRTL={true} />;
                }}
                onPressLeft={() => {
                    navigation.goBack();
                }}
            />
            <SafeAreaView style={BaseStyle.safeAreaView} edges={['right', 'left']}>
                <ScrollView
                    refreshControl={
                        <RefreshControl colors={[BaseColor.primary]} tintColor={BaseColor.primary} refreshing={false} onRefresh={onRefresh} />
                    }
                >
                    <View style={{ paddingVertical: 20 }}>
                        {!state.store?.assignedUsers ? (
                            <View>
                                <ActivityIndicator color={BaseColor.primary} size={'large'} />
                            </View>
                        ) : (
                            users?.map((user, index) => (
                                <View>
                                                                    {index>=1 && !isSelected(user.id)&&isSelected(users[index-1]?.id)&& <View style={{paddingHorizontal:20, paddingTop:30, paddingBottom:10}}><Text headline semibold>Mitglieder auswählen</Text></View>}
                                    <TouchableHighlight
                                        underlayColor={BaseColor.grayLight}
                                        activeOpacity={1}
                                        style={{
                                            flexDirection: 'row',
                                            padding: 10,
                                            borderBottomWidth: 1,
                                            borderBottomColor: BaseColor.grayLight,
                                            alignItems: 'center',
                                            opacity: 1,
                                        }}
                                        key={`${user.firstname} ${user.lastname}` + index}
                                        onPress={() =>
                                            state.loading == false &&
                                            assignUserToStore(
                                                state.store.id,
                                                user.id,
                                                () => setState((s) => ({ ...s, loading: user.id })),
                                                () => selectUser(user),
                                                () => setState((s) => ({ ...s, loading: false }))
                                            )
                                        }
                                    >
                                        <View style={{ flexDirection: 'row' }}>
                                            <View
                                                style={{
                                                    marginRight: 10,
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        backgroundColor: BaseColor.grayLight,
                                                        height: 40,
                                                        width: 40,
                                                        borderRadius: 15,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Icon name="user" type="ad" size={18} color={BaseColor.text} />
                                                </View>
                                            </View>

                                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                                <Text callout1>{`${user.firstname} ${user.lastname}`}</Text>
                                                <Text grayColor caption1>{user?.roles[0]?.name}</Text>
                                                <View style={{flexDirection:'row', alignItems:'center', marginTop:5}}>
                                                    {/* hier alle Positionen anzeigen, die den Kunden gehören */}
                                                    {user.positions?.filter(position=>position.clientId==state.store?.action?.clientId)?.map(position=><View style={{justifyContent:'center', alignItems:'center', paddingHorizontal:5, height:20, borderRadius:3, marginRight:3, backgroundColor:position.access=="ZM"? "#f0f0ff": BaseColor.grayLight}}><Text caption2>{position.title}</Text></View>)}
                                                    </View>   
                                                
                                            </View>
                                            <View
                                                style={{
                                                    marginRight: 10,
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        height: 40,
                                                        width: 40,
                                                        borderRadius: 15,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    {state.loading == user.id ? (
                                                        <ActivityIndicator color={BaseColor.primary} />
                                                    ) : (
                                                        <Icon
                                                            name="check"
                                                            type="ft"
                                                            size={20}
                                                            color={isSelected(user.id) ? BaseColor.primary : BaseColor.grayTransparent}
                                                        />
                                                    )}
                                                </View>
                                            </View>
                                        </View>
                                    </TouchableHighlight></View>
                                ))
                        )}
                    </View>
                </ScrollView>
            </SafeAreaView>
        </View>
    );
}

const menuIcon = {
    width: 60,
    height: 60,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOffset: {
        width: 0,
        height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 20,
    alignItems: 'center',
    justifyContent: 'center',
};
function mapState(state) {
    const { user, all } = state.users;
    return { user, allUser: all };
}

const actionCreators = {
    getSingleAction: actionActions.getSingle,
    assignUser: actionActions.assignUser,
    getUserAuth: userActions.getUserAuth,
    getAllUser: userActions.getAll,
};

export default connect(mapState, actionCreators)(AssignUserToStore);
